import { render, staticRenderFns } from "./serviceProvideManage.vue?vue&type=template&id=5da474a0&scoped=true"
import script from "./serviceProvideManage.vue?vue&type=script&lang=js"
export * from "./serviceProvideManage.vue?vue&type=script&lang=js"
import style0 from "./serviceProvideManage.vue?vue&type=style&index=0&id=5da474a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da474a0",
  null
  
)

export default component.exports